import reflection from "csi/reflection";
import { ATTR_PARENT, C8Node } from "csi/typings";
import ToolbarPluginButton from "csi/view/ToolbarPluginButton";
import _WidgetBase from "dijit/_WidgetBase";
import declare from "dojo/_base/declare";
import ProductType from "src/Apparel/ProductType";

export = declare([_WidgetBase, ToolbarPluginButton], {

	/**
	 * @override
	 * Don't show the switchboard if SharedSpecSections is empty
	 */
	canShowPlugin(): boolean {
		const view = this.getView();
		const viewNode: C8Node = view.getViewNode();
		const nodeClass = reflection.getNodeClass(viewNode);

		if (!nodeClass) {
			return false;
		}

		const product = nodeClass.isDerivedFrom("Product") ? viewNode :
			view.getCache().get(viewNode[ATTR_PARENT]);

		if (!product) {
			return false;
		}

		if (product.IsInspiration || ProductType.get(product, "ColorProductSources") !== "ColorProductSources:Enabled") {
			return false;
		}

		return product["ColorAllocationStatus"] !== "ColorAllocationStatus:Off";
	},
});